import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/ru.ts
var add = "Добавить";
var remove = "Удалить";
var removeAll = "Убрать все";
var incomplete = "Извините, не все поля заполнены верно.";
var submit = "Отправить";
var noFiles = "Файл не выбран";
var moveUp = "Переместить вверх";
var moveDown = "Переместить вниз";
var isLoading = "Загрузка...";
var loadMore = "Загрузить больше";
var next = "Следующий";
var prev = "Предыдущий";
var addAllValues = "Добавить все значения";
var addSelectedValues = "Добавить выбранные значения";
var removeAllValues = "Удалить все значения";
var removeSelectedValues = "Удалить выбранные значения";
var chooseDate = "Выберите дату";
var changeDate = "Изменить дату";
var close = "Закрыть";
var open = "Открыть";
var accepted = function({
  name
}) {
  return `Пожалуйста, примите ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `Дата ${sentence(name)} должна быть позже ${date(args[0])}.`;
  }
  return `Дата ${sentence(name)} должна быть в будущем.`;
};
var alpha = function({
  name
}) {
  return `Поле ${sentence(name)} может содержать только буквы.`;
};
var alphanumeric = function({
  name
}) {
  return `Поле ${sentence(name)} может содержать только буквы и цифры.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} могут содержать только буквы и пробелы.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} должен содержать алфавитные символы.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} должен содержать буквы или цифры.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} должно содержать буквы или пробелы.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} должен содержать символ.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} должно содержать прописные буквы.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} должно содержать строчные буквы.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} должен содержать числа.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} должен быть символом.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} может содержать только прописные буквы.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} может содержать только буквы нижнего регистра.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `Дата ${sentence(name)} должна быть раньше ${date(args[0])}.`;
  }
  return `Дата ${sentence(name)} должна быть в прошлом.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Это поле заполнено неверно и не может быть отправлено.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `Поле ${sentence(name)} должно быть между ${a} и ${b}.`;
};
var confirm = function({
  name
}) {
  return `Поле ${sentence(name)} не совпадает.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `Поле ${sentence(name)} имеет неверную дату. Пожалуйста, используйте формат ${args[0]}`;
  }
  return "Это поле заполнено неверно и не может быть отправлено.";
};
var date_between = function({
  name,
  args
}) {
  return `Дата ${sentence(name)} должна быть между ${date(args[0])} и ${date(args[1])}`;
};
var email = "Пожалуйста, введите действительный электронный адрес.";
var ends_with = function({
  name,
  args
}) {
  return `Поле ${sentence(name)} не должно заканчиваться на ${list(args)}.`;
};
var is = function({
  name
}) {
  return `Поле ${sentence(name)} имеет неподустимое значение.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `Поле ${sentence(name)} должно содержать минимум один символ.`;
  }
  if (min2 == 0 && max2) {
    return `Длина поля ${sentence(name)} должна быть меньше или равна ${max2} символам.`;
  }
  if (min2 === max2) {
    return `Длина ${sentence(name)} должна составлять ${max2} символов.`;
  }
  if (min2 && max2 === Infinity) {
    return `Длина поля ${sentence(name)} должна быть больше или равна ${min2} символам.`;
  }
  return `Длина поля ${sentence(name)} должна быть между ${min2} и ${max2} символами.`;
};
var matches = function({
  name
}) {
  return `Поле ${sentence(name)} имеет недопустимое значение.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Не может быть выбрано больше, чем ${args[0]} ${name}.`;
  }
  return `Поле ${sentence(name)} должно быть меньше или равно ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Не указаны поддержиавемые форматы файла.";
  }
  return `Формат файла в поле ${sentence(name)} должен быть: ${args[0]}.`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Не может быть выбрано меньше, чем ${args[0]} ${name}.`;
  }
  return `Поле ${sentence(name)} должно быть не менее, чем ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” не поддерживается в поле ${name}.`;
};
var number = function({
  name
}) {
  return `Поле ${sentence(name)} должно быть числом.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" или ")} требуется.`;
};
var required = function({
  name
}) {
  return `Поле ${sentence(name)} обязательно для заполнения.`;
};
var starts_with = function({
  name,
  args
}) {
  return `Поле ${sentence(name)} должно начинаться с ${list(args)}.`;
};
var url = function() {
  return `Пожалуйста, введите действительный URL-адрес.`;
};
var invalidDate = "Выбранная дата недействительна.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var ru_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, ru_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=ru.mjs.map